module.exports = __webpack_public_path__ + "img/zhejiang_unicom_bsp.b2018657.png";